<template>
   <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div class="container">
         <a
            v-popover
            ref="tooltip"
            href="/"
            class="navbar-brand"
            aria-label="Data Center Career Pathfinder home"
            data-container="body"
            data-toggle="popover"
            data-trigger="hover"
            data-placement="bottom"
            data-content="Return to homepage"
            ><img
               src="~@/assets/images/uptime-logo.png"
               alt="Uptime Institute logo"
               class="logo"
            /><br />
            Data Center Career Pathfinder</a
         >
         <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#top-navbar"
            aria-controls="top-navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
         >
            <span class="navbar-toggler-icon"></span>
         </button>

         <div id="top-navbar" class="collapse navbar-collapse">
            <ul class="navbar-nav mr-auto">
               <li
                  v-popover
                  ref="tooltip"
                  class="nav-item"
                  data-container="body"
                  data-toggle="popover"
                  data-trigger="hover"
                  data-placement="bottom"
                  data-content="Explore job domains"
                  data-page="Categories"
               >
                  <span v-if="this.$route.name === 'Categories'" class="no-link">Explore</span>
                  <a v-else href="/categories" class="nav-link">Explore</a>
               </li>
               <li
                  v-popover
                  class="nav-item"
                  data-container="body"
                  data-toggle="popover"
                  data-trigger="hover"
                  data-placement="bottom"
                  data-content="Job roles you starred as a favorite"
                  data-page="Favorites"
               >
                  <span v-if="this.$route.name === 'Favorites'" class="no-link">My favorites</span>
                  <a v-else ref="tooltip" href="/favorites" class="nav-link">My favorites</a>
               </li>
               <li
                  v-popover
                  ref="tooltip"
                  class="nav-item dropdown"
                  data-container="body"
                  data-toggle="popover"
                  data-trigger="hover"
                  data-placement="bottom"
                  data-content="Frequently asked questions and other industry links"
                  data-page="Resources"
               >
                  <!-- <div class="dropdown"> -->
                  <span v-if="this.$route.name === 'Resources'" class="no-link">Resources</span>
                  <a v-else ref="tooltip" href="/resources" class="nav-link">Resources</a>

                  <!-- div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="/info/#how-to"
                           >How to use the Career Pathfinder</a
                        >
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/info/#who-for">Who is this for?</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/info/#who-works"
                           >Who works in the data center sector?</a
                        >
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/info/#what-is">What is a data center?</a>
                     </div -->
                  <!-- </div> -->
               </li>
            </ul>
            <div>
               <form class="form-inline my-2 my-lg-0" onsubmit="return false;">
                  <input
                     v-popover
                     id="freetext"
                     ref="tooltip"
                     v-model.lazy="freetext"
                     class="form-control mr-sm-2 form-control-sm"
                     @input="inputChanged"
                     type="search"
                     placeholder="Search"
                     aria-label="Search"
                     data-container="body"
                     data-toggle="popover"
                     data-trigger="hover"
                     data-placement="bottom"
                     data-content="Search by job domain, key competencies, education, keywords, etc."
                  />
                  <div class="search-exact">
                     <label><input type="checkbox" id="exact" />Exact<br />Match</label>
                  </div>
                  <button class="btn btn-sm btn-dark my-2 my-sm-0" @click="search()">Search</button>
               </form>
            </div>
         </div>
      </div>
   </nav>
</template>

<script>
// uses jquery-ui for autocomplete
import $ from 'jquery';
import 'jquery-ui';

export default {
   name: 'TopNav',
   data: function () {
      return {
         freetext: this.$store.state.filters.freetext,
         exact: this.$store.state.filters.exact,
      };
   },
   created: function () {
      // watch Vuex for changes to the store (filters)
      this.unwatch = this.$store.watch(
         (state) => [state.filters.freetext],
         (watched) => {
            this.freetext = watched[0];
         }
      );
   },
   beforeDestroy: function () {
      this.unwatch();
   },
   mounted: function () {
      // enable autocomplete for the search box
      $('#freetext').autocomplete({
         source: this.$predictiveArray(),
      });

      // make a copy of the vue instance for use in the jquery function
      let myVue = this;
      // attach to the select event
      // set the exact match checked if they select
      // an item from the autocomplete list
      $('#freetext').on('autocompleteselect', function (event, ui) {
         myVue.exact = true;
         myVue.$store.commit('filters/setExact', {
            exact: myVue.exact,
         });
         $('#exact').prop('checked', true);
      });

      ['Categories', 'Favorites', 'Resources'].forEach((page) => {
         const elem = $(`[data-page="${page}"]`);
         if (this.$route.name === page) {
            elem.popover('disable');
         } else {
            elem.popover('enable');
         }
      });
      switch (this.$route.name) {
         case 'Careers':
            break;
         default:
            this.$store.commit('filters/setFreetext', {
               text: null,
            });
            break;
      }
   },
   methods: {
      inputChanged(event) {
         // called when the input field changes
         // if it does, clear the exact match
         // console.log('change', event);
         $('#exact').prop('checked', false);
      },
      search: function () {
         // fix for autocomplete on safari...
         var input = $('#freetext').val();
         // console.log('setting freetext to ', input);
         this.freetext = input;
         this.exact = $('#exact').is(':checked');

         this.$store.commit('filters/setFreetext', {
            text: this.freetext,
         });

         this.$store.commit('filters/setExact', {
            exact: this.exact,
         });

         switch (this.$route.name) {
            case 'Careers':
               this.$emit('do-search');
               break;
            case 'Categories':
               this.$router.push({
                  path: 'careers',
                  query: this.$store.getters['filters/allParams'],
               });
               break;
            default:
               this.$router.push({path: '/careers', query: {text: this.freetext}});
               break;
         }
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/TopNav.vue